import OrderReceiverSelect from "./orderReceiverSelect.container";

export default OrderReceiverSelect;
